import React, { useContext, useEffect, useState } from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap';
import { AudioPlayerContext } from './AudioPlayerContext';
import { useNavigate, useParams } from 'react-router-dom';
import Lottie from 'lottie-react';
import music_playing from './music_playing.json'
import './episodes.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import {
    faHeart as regularHeart
} from '@fortawesome/free-regular-svg-icons';
import axios from 'axios';
import { toast } from 'react-toastify';
import { logAudioClick, SECTIONS } from '../../utils/contentConsumption';
const Episodes = ({ episodes, thumb, id }) => {
    const [isLiked, setIsLiked] = useState(false)
    const navigate = useNavigate()
    const {
        setTrack,
        currentTrack,
        isPlaying,
        pauseTrack,
        playTrack,
        duration,
        currentTime,
        seekTo,
        audioRef,
        episodeThumb,
        currentEpisodeNumber,
        totalEpisodeCount,
        audioTracks,
        showPlayer,
        currentTrackLanguage
    } = useContext(AudioPlayerContext);
    const user_id = localStorage.getItem('dastaan__user_id') !== null ? localStorage.getItem('dastaan__user_id') : null
    const plan_status = localStorage.getItem('dastaan__plan_active') === 'false' ? 0 : 1
    const playing_id = currentTrack !== null ? currentTrack.id : 0
    useEffect(() => {

        getAudioFileDetails()
    }, [showPlayer])
    const handlePlay = (current_episode, index, episode_id) => {
        localStorage.setItem('audio_file_id', id); // replace with actual key-value
        logAudioClick(id, SECTIONS.EPISODE_PLAY);
        console.log('***************************************** E P I S O D E S ****************************************');
        console.table(episodes);
        console.log('***************************************************************************************************');
        if (currentTrack === null) {
            playTrack(episodes, current_episode, index, thumb, 0, 0, 0)
            return
        }
        const playing_episode_id = currentTrack.id
        if (pauseTrack) {
            if (isPlaying) {
                if (episode_id == playing_episode_id) {
                    pauseTrack(true)
                }
                else {
                    playTrack(episodes, current_episode, index, thumb, 0, 0)
                }
            }
            else if (episode_id == playing_episode_id) {
                pauseTrack(false)
            }
            else {
                playTrack(episodes, current_episode, index, thumb, 0, 0)
            }
        }
        else if (episode_id === playing_episode_id) {
            pauseTrack(false)
        }
    };
    const getAudioFileDetails = async () => {
        try {
            const data = JSON.stringify({
                'user_id': localStorage.getItem('dastaan__user_id') !== null ? localStorage.getItem('dastaan__user_id') : 1,
                audio_file_id: id
            });
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${process.env.REACT_APP_API_URL}/audio-file-detail`,
                headers: {
                    'Authorization': localStorage.getItem('dastaan__token'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios.request(config).then((response) => {
                const resData = response.data.Podcast_App;
                const audio_file_detail = resData.audio_file_data;
                const pS = localStorage.getItem('dastaan__plan_active');
                if (pS !== resData.user_plan_status) {
                    localStorage.removeItem('dastaan__plan_active');
                    localStorage.setItem('dastaan__plan_active', resData.user_plan_status);
                }
                setIsLiked(audio_file_detail.isliked !== null ? (audio_file_detail.isliked === 1 ? true : false) : false)
            })
        } catch (error) {
        }
    }
    const handleLikeDislike = async (e) => {
        e.stopPropagation(); // Prevent bubbling if needed
        let is_disliked = false;
        let is_liked = false;
        let audio_file_id = id;
        try {
            if (isLiked === false) {
                setIsLiked(true)
                is_disliked = false;
                is_liked = true;
                // toast('Disliked');
            }
            else if (isLiked === true) {
                setIsLiked(false)
                is_disliked = true;
                is_liked = false
                // toast('Liked');
            }
            const data = {
                "user_id": localStorage.getItem('dastaan__user_id'), // integer
                audio_file_id,//integer
                is_liked,
                is_disliked //boolean
            };
            const config = {
                method: 'POST',
                maxBodyLength: Infinity,
                url: `${process.env.REACT_APP_API_URL}/add-remove-likes`,
                headers: {
                    'Authorization': localStorage.getItem('dastaan__token'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: data
            };
            await axios(config).then((response) => {
                //window.location.reload()
            });
        } catch (error) {
            console.log(error);
        }
    };
    if (episodes.length === 0) {
        return (
            <Container className='mt-1 mb-3 audio-player-episodes'>
                <Row>
                    <Col md={12} sm={12}>
                        <h3>Episodes not added!</h3>
                    </Col>
                </Row>
            </Container>
        )
    } else {
        return (
            <Container className='mt-1 mb-3 audio-player-episodes' style={{ paddingBottom: showPlayer === true ? "30%" : "0%" }} >
                <Row>
                    <Col md={12} sm={12} xs={12} className='mb-3'
                        style={{ borderBottom: '1px solid #80808063' }} >
                        <Row>
                            <Col md={4} sm={4} xs={4}>
                                <h6><b>Episodes</b></h6>
                            </Col>
                            <Col md={8} sm={8} xs={8} className='text-right xs-none'>
                                <div onClick={handleLikeDislike}>
                                    <FontAwesomeIcon
                                        style={{ color: 'white', fontWeight: 900 }}
                                        aria-hidden="true" icon={isLiked === true ? faHeart : regularHeart} />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    {
                        episodes.map((item, index) => {
                            const hour = (parseFloat(item.duration) / 3600).toFixed(2)
                            const hrArr = hour.split('.');
                            const min = (hrArr[1]);
                            const seconds = min / 60;
                            return (
                                <Col md={12} sm={12} xs={12} key={index}
                                >
                                    <Row className='p-2' onClick={() => user_id !== null ? (plan_status === 1 ? handlePlay(index + 1, index, item.id) : navigate('/plans')) : navigate('/login')}>
                                        <Col sm={1} md={2} xs={1}  >
                                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                                <Image src={thumb} className="epiasode-thumbnail" />
                                                {playing_id === item.id && isPlaying && (
                                                    <Lottie animationData={music_playing} loop={true}
                                                        style={{
                                                            position: 'absolute',
                                                            top: '10px',
                                                            right: '12px',
                                                            width: '30px',
                                                        }}
                                                    />
                                                    /*  <Image
                                                     style={{
                                                         position: 'absolute',
                                                         top: '95px',
                                                         right: '12px',
                                                         width: '30px',
                                                       }}
                                                         src={`${process.env.PUBLIC_URL}/player_icons/playing_track.svg`}
                                                         className="epiasode-thumbnail-playing"
                                                     /> */
                                                )}
                                            </div>
                                        </Col>
                                        <Col sm={9} md={9} xs={8} className={`text-left audio-title-detail ${playing_id === item.id ? 'audio-title-detail-active' : ''}  `}>
                                            <h6><b>{item.title}</b></h6>
                                            <p className='time-info'>{hrArr[0]}:{min}:{seconds > 0 ? parseInt(seconds) : '00'}</p>
                                        </Col>
                                        <Col sm={1} md={1} xs={2} className='pointer'>
                                            <Image className='play-pause-btn'
                                                // src={`${process.env.PUBLIC_URL}/player_icons/list_play_btn.svg`}
                                                src={
                                                    playing_id === item.id && isPlaying
                                                        ? `${process.env.PUBLIC_URL}/player_icons/list_pause_btn.svg`
                                                        : `${process.env.PUBLIC_URL}/player_icons/list_play_btn.svg`
                                                }
                                            />
                                            {/* <FontAwesomeIcon className='episode-play-button' icon={faPlay} /> */}
                                        </Col>
                                    </Row>
                                </Col>
                            )
                        }
                        )
                    }
                </Row>
            </Container>
        )
    }
}
export default Episodes